module.exports = __webpack_public_path__ + "media/images/leads_generation/logo-speedio-5d6710af07a1cf223078617e2bbb4408.svg";